import { defineStore } from "pinia";
import { ref } from "vue-demi";
import { postData } from "@utils";

export const useAllergenStore = defineStore("allergen", () => {
  const allergenNames = ref({});
  const allergenExcluded = ref({});
  const isLoading = ref(false);
  const isLoaded = ref(false);

  const fetchAllergenData = async () => {
    // Eğer zaten yüklendiyse tekrar API isteği yapma
    if (isLoaded.value) return;

    // Eğer yükleme işlemi devam ediyorsa bekle
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const data = new FormData();
      data.append("method", "vendorFormOperations");
      data.append("func", "getAllergenQuestionList");

      const response = await postData(data);
      if (response && response.length) {
        response.forEach(item => {
          allergenNames.value[item.id] = item.stext;
          allergenExcluded.value[item.id] = item.excludedProducts;
        });
        isLoaded.value = true;
      }
    } catch (error) {
      console.error("Alerjen verileri yüklenirken hata:", error);
    } finally {
      isLoading.value = false;
    }
  };

  // Alerjen adını alma
  const getAllergenName = (id) => {
    return allergenNames.value[id] || `Alerjen #${id}`;
  };

  // Hariç tutulan ürünleri alma
  const getAllergenExcluded = (id) => {
    const excluded = allergenExcluded.value[id];
    if (!excluded || excluded === '-' || excluded === '') return '-';
    return excluded.replace(/<br\/>/g, ', ');
  };

  return {
    allergenNames,
    allergenExcluded,
    isLoading,
    isLoaded,
    fetchAllergenData,
    getAllergenName,
    getAllergenExcluded,
  };
});
